import { useLocationMutation, useLocationQuery } from '@features/redux/apis/org';
import { useAlert } from '@hooks/useAlert';
import { MutationEffect } from '@helpers/MutationEffect';
import { QueryEffect } from '@helpers/QueryEffect';
import { useQuery } from '@hooks/useQuery';
import { Operation } from '@/types/general';

export const LocationEffects = () => {
    const locationId = useQuery().get('id');
    const operation = locationId ? Operation.Edit : Operation.Create;

    const queryState = useLocationQuery({ locationId: +locationId! }, { skip: operation === Operation.Create });

    const [, mutationState] = useLocationMutation({
        fixedCacheKey: operation === Operation.Edit ? 'LocationMutation' : 'LocationCreation',
    });

    const { setAlert } = useAlert();

    return (
        <>
            <MutationEffect
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                mutationState={mutationState}
                effects={{
                    isError: () => {
                        setAlert(`Failed to ${operation} Location`, 'error');
                        mutationState.reset();
                        return;
                    },
                    isSuccess: () => {
                        setAlert('Successfully saved location.', 'success');
                        mutationState.reset();
                    },
                }}
            />

            <QueryEffect
                queryState={queryState}
                effects={{
                    isError: () => {
                        setAlert('Failed to load Location Data', 'error');
                    },
                }}
            />
        </>
    );
};
